import { watchEffect, type Directive } from 'vue'
import { useAuthStore } from '@/stores/auth'

type PermissionValue = string | string[]
const values = new WeakMap<HTMLElement, PermissionValue>()
const effects = new WeakMap<HTMLElement, ReturnType<typeof watchEffect>>()

function applyPermission(el: HTMLElement, value: PermissionValue) {
  const codes = Array.isArray(value) ? value : [value]
  el.hidden = codes.length > 0 && !codes.every(code => useAuthStore().hasPermission(code))
}

export const permission: Directive<HTMLElement, PermissionValue> = {
  mounted(el, binding) {
    values.set(el, binding.value)
    effects.set(el, watchEffect(() => applyPermission(el, values.get(el) || [])))
  },
  updated(el, binding) {
    values.set(el, binding.value)
    applyPermission(el, binding.value)
  },
  unmounted(el) {
    effects.get(el)?.stop()
    effects.delete(el)
    values.delete(el)
  },
}
